import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { cn } from '@duck/ui'
import { useTheme } from '@/contexts/ThemeContext'
import { useTar } from '@/modules/i18n/useTar'

export const SidebarThemeButton = () => {
  const { isDark, setTheme } = useTheme()
  const { t } = useTar()

  const handleClick = () => {
    setTheme(isDark ? 'light' : 'dark')
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={isDark}
      aria-label={t('themes.toggleTheme')}
      title={t(isDark ? 'themes.lightMode' : 'themes.darkMode')}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-md',
        ' bg-transparent text-muted-foreground',
        'transition-colors hover:bg-accent/10 hover:text-foreground active:bg-accent/20',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
      )}
    >
      {isDark ? (
        <SunIcon data-icon="sun" className="h-[18px] w-[18px]" />
      ) : (
        <MoonIcon data-icon="moon" className="h-[18px] w-[18px]" />
      )}
    </button>
  )
}
